import { Component } from '@angular/core';

import { QuotationPanelComponent } from './quotation-panel/quotation-panel.component';

@Component({
  selector: 'app-root',
  imports: [QuotationPanelComponent],
  template: '<app-quotation-panel />',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
